<template>
  <div id="app">
    <Header />
    <AppLoading />
    <ErrorToken v-show="showError" />
    <div>
      <div>
        <div class="priorities">
          <div class="priority">
            <div class="color-box priority-one"></div>
            <div>Muy prioritario</div>
          </div>
          <div class="priority">
            <div class="color-box priority-two"></div>
            <div>Prioritario</div>
          </div>
          <div class="priority">
            <div class="color-box priority-three"></div>
            <div>Moderado</div>
          </div>
          <div class="priority">
            <div class="color-box priority-four"></div>
            <div>Menos prioritario</div>
          </div>
        </div>
        <kanbaTable />
      </div>
    </div>
    <div class="loading-spinner" v-show="showLoading">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import AppLoading from "./components/AppLoading.vue";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ErrorToken from "./components/errorToken.vue";
import Header from "./components/Header.vue";
import Cookies from "js-cookie";
import kanbaTable from "./components/kanbaTable.vue";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "App",
  components: {
    ErrorToken,
    Header,
    kanbaTable,
    AppLoading,
  },
  setup() {
    const store = useStore();
    const showError = ref(false);

    const checkError = () => {
      const token = Cookies.get("thoth_token");
      const ApiUser = Cookies.get("apiUser");
      if (!token || !ApiUser) {
        showError.value = true;
      } else {
        showError.value = false;
      }
    };

    const fetchProjects = async () => {
      store.dispatch("app/showLoading");
      try {
        await store.dispatch("fetchProjects");
      } finally {
        store.dispatch("app/hideLoading");
      }
    };

    onMounted(() => {
      fetchProjects();
      checkError();
    });
  },
};
</script>

<style>
@import "~bootstrap/dist/css/bootstrap.css";
body {
  background-image: url("assets/icons/Board-Version3.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #141218;
  overflow-y: hidden;
}

* {
  zoom: 1;
  color: white;
}

.board::-webkit-scrollbar,
body::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.board::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb {
  background: #ffffff41;
}

.priorities {
  margin-right: 0.5rem;
  display: flex;
  overflow: auto;
  justify-content: right;
}

.priority {
  margin: 5px;
  display: flex;
  align-items: center;
}

.color-box {
  margin: 5px;
  width: 20px;
  height: 20px;
  border-radius: 0.3rem;
  border: solid 1px gray;
}

.priority-one {
  background-color: #22070d;
}

.priority-two {
  background-color: #3b264d;
}

.priority-three {
  background-color: #26304d;
}

.priority-four {
  background-color: #26454d;
}

.inline {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inlineRight {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn {
  padding: 0.3rem 0.8rem 0.3rem 0.8rem;
  font-size: 14px;
}
.right {
  background-color: #1f3e30;
  font-weight: bold;
  margin-right: 2px;
  padding: 0.1rem 0.8rem 0.1rem 0.8rem;
}
.rightPriority {
  font-weight: bold;
  padding: 0.1rem 0.8rem 0.1rem 0.8rem;
}
.card h6 {
  margin: 3px;
  color: white;
}
.card p {
  margin: 3px;
  font-size: 14px;
}
.card:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  transition: box-shadow 0.3s;
}
@media only screen and (max-width: 768px) {
  .priorities {
    justify-content: flex-start;
    overflow: auto;
  }
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.cardsAnim-enter-from,
.cardsAnim-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.cardsAnim-enter-to,
.cardsAnim-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.cardsAnim-enter-active,
.cardsAnim-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.loading-spinner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(78, 78, 78, 0.404);
  z-index: 1;
}
.spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #f46516;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
